import type {
  FontFamily,
  TypographyElementProps,
  TypographyStyle,
} from '~/elc/features/enterprise-settings/components/TypographyElement/types';

export const normalizeStringCSS = (css: string) => css.replace(/\s+/g, ' ').trim();

const getElementStyles = (elements: TypographyElementProps[]) =>
  elements
    .map(
      ({ elementType, fontSize, fontWeight, fontColor }) => `
      ${elementType} {
        font-size: ${fontSize}px;
        font-weight: ${fontWeight};
        color: ${fontColor};
      }
    `,
    )
    .join('\n');

const getHeadingStyles = (headingFontFamily: FontFamily) => `
  h1, h2, h3, h4, h5, h6 {
    font-family: ${headingFontFamily.fontFamily};
  }
`;

const getBodyStyles = (bodyFontFamily: FontFamily, elements: TypographyElementProps[]) => `
  font-family: ${bodyFontFamily.fontFamily};
  color: ${elements.find(({ elementType }) => elementType === 'p')?.fontColor};
  font-size: ${elements.find(({ elementType }) => elementType === 'p')?.fontSize}px;
  font-weight: ${elements.find(({ elementType }) => elementType === 'p')?.fontWeight};
`;

export const typographyStyleToStringCSS = (typographyStyle: TypographyStyle) => {
  if (
    !typographyStyle ||
    !typographyStyle.bodyFontFamily ||
    !typographyStyle.headingFontFamily ||
    !typographyStyle.elements
  ) {
    return undefined;
  }

  const { bodyFontFamily, headingFontFamily, elements } = typographyStyle;

  const styles = `
    ${getHeadingStyles(headingFontFamily)}
    ${getBodyStyles(bodyFontFamily, elements)}
    ${getElementStyles(elements)}
  `;

  return normalizeStringCSS(styles);
};

export const typographyStyleToStringCSSForEditor = (typographyStyle: TypographyStyle) => {
  if (
    !typographyStyle ||
    !typographyStyle.bodyFontFamily ||
    !typographyStyle.headingFontFamily ||
    !typographyStyle.elements
  ) {
    return undefined;
  }

  const { bodyFontFamily, headingFontFamily, elements } = typographyStyle;

  const styles = `
    ${getHeadingStyles(headingFontFamily)}
    body {
      ${getBodyStyles(bodyFontFamily, elements)}
    }
    ${getElementStyles(elements)}
  `;

  return normalizeStringCSS(styles);
};
